import { useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';

import useAirport from '../../components/Airport/hooks/useAirport/useAirport';
import useSearchQuery, { SearchQueryValues } from '../useSearchQuery';
import { validate } from './utils';

const usePackageSearch = () => {
  const { value: originCode, setValue: setStoredOriginCode } = useAirport({
    parameterName: 'originCode',
  });

  const router = useRouter();
  const { searchQuery, setSearchQuery } = useSearchQuery();
  const {
    departureDate,
    returnDate,
    adults = 2,
    children = 0,
    infants = 0,
    packageOption,
  } = searchQuery || {};

  const [data, setData] = useState({
    originCode,
    departureDate,
    returnDate,
    adults,
    children,
    infants,
    packageOption,
  });

  useEffect(() => {
    if (router.isReady) {
      setData({
        originCode,
        departureDate,
        returnDate,
        adults,
        children,
        infants,
        packageOption,
      });
    }
  }, [
    adults,
    children,
    departureDate,
    infants,
    originCode,
    packageOption,
    returnDate,
    router.isReady,
  ]);

  const error = useMemo(() => validate(data), [data]);

  const handleChangeData = (newData: SearchQueryValues) => {
    if (newData?.originCode) {
      setStoredOriginCode(newData.originCode);
      setSearchQuery({
        originCode: newData.originCode,
      });
    }

    if (!!newData?.adults || !!newData?.children || !!newData?.infants) {
      setSearchQuery({
        adults: newData.adults,
        children: newData.children,
        infants: newData.infants,
      });
    }

    if (newData?.packageOption) {
      setSearchQuery({ packageOption: newData.packageOption });
    }

    setData({
      ...data,
      ...newData,
    });
  };

  const handleSearch = (newData?: SearchQueryValues) => {
    if (newData) {
      setData((oldData) => ({ ...oldData, ...newData }));
      setSearchQuery({ ...data, ...newData });
    } else {
      setSearchQuery(data);
    }
  };

  useEffect(() => {
    setData((data) => ({
      ...data,
      originCode,
    }));
  }, [originCode]);

  return {
    data,
    handleChangeData,
    handleSearch,
    error,
    validate,
  };
};
export default usePackageSearch;
